import React, { useState, useEffect } from "react";
import { AlertCircle, Eye, X } from "lucide-react";
import PageHeader from "../../components/PageHeader";
import DataTable from "../../components/DataTable";
import { listFinanceBillingEvents } from "../../services/adminFinance";

const BillingEvents = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [items, setItems] = useState([]);
  const [pagination, setPagination] = useState({ pageNumber: 1, pageSize: 20, total: 0, totalPages: 1 });
  const [detail, setDetail] = useState(null);

  useEffect(() => { load(1); }, []);

  const load = async (page = 1) => {
    setLoading(true); setError("");
    try {
      const data = await listFinanceBillingEvents({ pageNumber: page, pageSize: 20, sortBy: "occurredAt", sortOrder: "DESC" });
      setItems(data.items || []);
      setPagination(data.pagination || {});
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const columns = [
    { header: "ID", render: (r) => <span className="font-mono text-purple-400 text-xs">#{r.id}</span> },
    { header: "Evento", render: (r) => <span className="text-xs font-bold">{r.eventType}</span> },
    { header: "Entidade", render: (r) => <span className="text-xs">{r.entityType} #{r.entityId}</span> },
    { header: "Empresa", render: (r) => <span className="text-xs">#{r.companyId}</span> },
    { header: "Ocorrido", render: (r) => <span className="text-xs text-gray-500">{r.occurredAt ? new Date(r.occurredAt).toLocaleString("pt-BR") : "—"}</span> },
    { header: "Ações", render: (r) => <button onClick={() => setDetail(r)} className="p-1 rounded-lg bg-black/5 dark:bg-white/5 hover:bg-purple-500/20 text-purple-600 dark:text-purple-400"><Eye size={15} /></button> }
  ];

  return (
    <div className="space-y-4">
      <PageHeader breadcrumb="Financeiro" title="Eventos de Cobrança" subtitle={`${pagination.total || 0} evento(s)`} />
      {error && <div className="p-3 rounded-xl bg-rose-500/10 border border-rose-500/20 text-rose-600 dark:text-rose-300 text-xs font-semibold flex items-center gap-3"><AlertCircle size={16} /> {error}</div>}
      <DataTable columns={columns} data={items} loading={loading} emptyTitle="Nenhum evento" />
      {detail && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
          <div className="neumorphic-card rounded-3xl w-full max-w-lg p-6 border border-gray-200 dark:border-white/10 space-y-3 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between border-b border-gray-100 dark:border-white/5 pb-3">
              <h3 className="text-base font-bold text-gray-900 dark:text-white">Evento #{detail.id}</h3>
              <button onClick={() => setDetail(null)} className="text-gray-400 hover:text-gray-700 dark:hover:text-white"><X size={18} /></button>
            </div>
            <div className="grid grid-cols-2 gap-3 text-xs">
              <div><span className="text-gray-500">Tipo:</span> <span className="font-bold">{detail.eventType}</span></div>
              <div><span className="text-gray-500">Entidade:</span> {detail.entityType} #{detail.entityId}</div>
              <div><span className="text-gray-500">Empresa:</span> #{detail.companyId}</div>
              <div><span className="text-gray-500">Ocorrido:</span> {detail.occurredAt ? new Date(detail.occurredAt).toLocaleString("pt-BR") : "—"}</div>
            </div>
            {detail.metadata && (
              <div>
                <span className="text-[10px] font-semibold text-gray-500 uppercase">Metadata</span>
                <pre className="mt-1 p-2 bg-gray-50 dark:bg-[#191c1e] rounded-lg text-[10px] font-mono overflow-x-auto">{JSON.stringify(detail.metadata, null, 2)}</pre>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BillingEvents;
